import moment from "moment";

export const timestampToReadable = (timestamp: Date | number): string => {
  if (timestamp == null) return "-";
  const date = new Date(timestamp);
  return moment(date).format("LT, D MMMM");
  // return `${date.getHours()}:${date.getMinutes()}:${date.getSeconds()} ${date.getDate()}.${date.getMonth()}.${date.getUTCFullYear().toString().substr(-2)}`
};

export const timestampToReadableZone = (timestamp: Date | number): string => {
  if (timestamp == null) return "-";
  const date = moment.utc(timestamp).local();
  return date.format("LT, D MMMM");
};

export const timestampToDatetime = (timestamp: number): string => {
  const date = new Date(timestamp);
  return date.toLocaleString();
};
